  import firebase from 'firebase'
  import firestore from 'firebase/firestore'
  
  // Your web app's Firebase configuration
  var firebaseConfig = {
    apiKey: "AIzaSyCyORHIoENk4ZT8X5PJgnqx2QQIZJKnX-Q",
    authDomain: "offices-eb9f2.firebaseapp.com",
    databaseURL: "https://offices-eb9f2.firebaseio.com",
    projectId: "offices-eb9f2",
    storageBucket: "offices-eb9f2.appspot.com",
    messagingSenderId: "290564883132",
    appId: "1:290564883132:web:3c67e04dd22c161a2f06b9"
  };
  
  // Initialize Firebase
  const firebaseApp = firebase.initializeApp(firebaseConfig);

  export default firebaseApp.firestore();


// WEBPACK FOOTER //
// ./src/firebase/init.js